export enum TraderProfitabilityTag {
  profitable = 'profitable',
  breakeven = 'breakeven',
  losing = 'losing',
  unknown = 'unknown',
}

export enum TraderProfitabilityUnknownReason {
  notCalculated = 'not_calculated',
  noEligibleAccount = 'no_eligible_account',
  unsupportedCurrency = 'unsupported_currency',
  noClosedTrades = 'no_closed_trades',
  insufficientTrades = 'insufficient_trades',
}

export type TraderProfitabilityMetrics = {
  profitabilityTag?: TraderProfitabilityTag
  profitabilityUnknownReason?: TraderProfitabilityUnknownReason | null
  profitabilityNetPnl30dUsd?: number | null
  profitabilityNativeNetPnl?: number | null
  profitabilityNativeCurrency?: string | null
  profitabilityTradeCount30d?: number
  profitabilityWinRate30d?: number | null
  profitabilityProfitFactor30d?: number | null
  profitabilityWindowStartedAt?: string | null
  profitabilityCalculatedAt?: string | null
  profitabilityAllTimeNetPnlUsd?: number | null
  profitabilityAllTimeTradeCount?: number
  profitabilityAllTimeWinRate?: number | null
  profitabilityAllTimeProfitFactor?: number | null
  profitabilityLastTradeAt?: string | null
}
